// extracted by mini-css-extract-plugin
module.exports = {"link":"logout_link__28otc","alink":"logout_alink__3v2fM"};